var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpDownarrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4533 10.7715H6.81914H3.54664C2.98664 10.7715 2.70664 11.4482 3.10331 11.8448L6.12498 14.8665C6.60914 15.3507 7.39664 15.3507 7.88081 14.8665L9.02998 13.7173L10.9025 11.8448C11.2933 11.4482 11.0133 10.7715 10.4533 10.7715Z",
    fill: "#9B9B9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8967 8.15432L9.02419 6.28182L7.88085 5.13266C7.39669 4.64849 6.60919 4.64849 6.12502 5.13266L3.10335 8.15432C2.70669 8.55099 2.99252 9.22766 3.54669 9.22766H6.81919H10.4534C11.0134 9.22766 11.2934 8.55099 10.8967 8.15432Z",
    fill: "#9B9B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpDownarrows);
export default __webpack_public_path__ + "static/media/upDownarrows.f704165f49d0d309003cfc70004ed554.svg";
export { ForwardRef as ReactComponent };